import { Box } from '#/components/Box/Box';
import { StyledNativeLinkWithRef } from '#/components/Link/StyledNativeLinkWithRef';
import { H2 } from '#/components/Text/H2';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { CmsApiPage } from '#/modules/cms/api/types/CmsApiPage';
import type { CmsApiGradFairGradProgramLinksBlockData } from '#/modules/cms/api/types/blocks/CmsApiGradFairGradProgramLinksBlock';
import { getIsContentFullWidthLayout } from '#/modules/cms/helpers/getIsContentFullWidthLayout';

type Props = {
  content: CmsApiPage;
  data: CmsApiGradFairGradProgramLinksBlockData;
};

export function CmsGradFairGradProgramLinksBlock({
  content,
  data: { orgs },
}: Props) {
  const { i18n, locale } = useI18n();

  const fullWidthLayout = getIsContentFullWidthLayout({ content });

  return (
    <Box
      qaId="cms-grad-fair-grad-program-links"
      textAlign={fullWidthLayout ? 'center' : undefined}
    >
      <H2>{i18n('Participating Programs')}</H2>

      <Box
        display="flex"
        flexDirection={['column', 'row', 'row', 'row', 'row']}
        mt={[36, null, null, 48]}
        mb={-12}
        style={{ gap: '60px' }}
      >
        <Box
          textAlign={['center', 'left', 'left', 'left', 'left']}
          width={['100%', '50%', '50%', '50%', '50%']}
        >
          {orgs
            .slice(0, Math.ceil(orgs.length / 2))
            .map(({ id, name, url }) => (
              <Box key={id} py={12} qaId="program-link">
                <StyledNativeLinkWithRef href={url[locale]}>
                  {name}
                </StyledNativeLinkWithRef>
              </Box>
            ))}
        </Box>

        <Box
          textAlign={['center', 'left', 'left', 'left', 'left']}
          width={['100%', '50%', '50%', '50%', '50%']}
        >
          {orgs.slice(Math.ceil(orgs.length / 2)).map(({ id, name, url }) => (
            <Box key={id} py={12} qaId="program-link">
              <StyledNativeLinkWithRef href={url[locale]}>
                {name}
              </StyledNativeLinkWithRef>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
